import { isDateInPeriod } from '../../utils/dates';
import moment from 'moment';

export const IsSeasonDateHasLocation = (periods, date) => {
  return periods.some((period) => {
    return isDateInPeriod(period.install_date, period.removal_date, date);
  });
};

export const CustomLabelFormat = ([startTime], unit, labelWidth) => {
  const format = {
    month: {
      long: 'MMMM',
      middle: 'MMM',
      short: 'MM',
    },
    day: {
      long: 'ddd, D',
      middle: 'ddd, D',
      short: 'D',
    },
  };
  const date = startTime.toLocaleString();
  if (labelWidth > 80) {
    return moment(date).format(format[unit].long);
  } else if (labelWidth > 40) {
    return moment(date).format(format[unit].middle);
  }
  return moment(date).format(format[unit].short);
};

export const CustomTopLabelFormat = ([startTime], unit) => {
  const format = {
    year: 'YYYY',
    month: 'MMMM YYYY',
  };
  const date = startTime.toLocaleString();
  return moment(date).format(format[unit]);
};